
const BequestContent = () => {
    return (
        <>
            <h4>
                The Bequest Program Commences
            </h4>
            <p>
                Over the following 20 years, thanks to the kindness of 93 supporters, $6.2M has been donated to Breast Cancer Trials via Gifts in Wills. 
            </p>
        </>
    );
}

export default BequestContent;